import React from "react";

export const DeepSpaceBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Deep space gradient base */}
      <div 
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(ellipse at 20% 20%, rgba(88, 28, 135, 0.06) 0%, transparent 50%),
            radial-gradient(ellipse at 80% 80%, rgba(30, 58, 138, 0.06) 0%, transparent 50%),
            radial-gradient(ellipse at 50% 50%, rgba(25, 39, 66, 1) 0%, rgba(18, 28, 50, 1) 100%)
          `,
        }}
      />

      {/* Nebula clouds */}
      <div 
        className="absolute top-0 left-0 w-full h-full opacity-30 animate-[drift_60s_ease-in-out_infinite]"
        style={{
          background: `
            radial-gradient(ellipse 600px 400px at 15% 25%, rgba(139, 92, 246, 0.2) 0%, transparent 70%),
            radial-gradient(ellipse 500px 350px at 85% 75%, rgba(59, 130, 246, 0.15) 0%, transparent 70%)
          `,
        }}
      />
      
      <div 
        className="absolute top-0 left-0 w-full h-full opacity-20 animate-[drift_80s_ease-in-out_infinite_reverse]"
        style={{
          background: `
            radial-gradient(ellipse 400px 300px at 70% 20%, rgba(236, 72, 153, 0.12) 0%, transparent 70%),
            radial-gradient(ellipse 450px 350px at 25% 80%, rgba(34, 211, 238, 0.1) 0%, transparent 70%)
          `,
        }}
      />

      {/* Shooting stars */}
      <div className="shooting-star absolute" style={{ top: '10%', left: '10%', animationDelay: '0s' }} />
      <div className="shooting-star absolute" style={{ top: '20%', left: '60%', animationDelay: '4s' }} />
      <div className="shooting-star absolute" style={{ top: '50%', left: '30%', animationDelay: '8s' }} />
      <div className="shooting-star absolute" style={{ top: '70%', left: '80%', animationDelay: '12s' }} />
      <div className="shooting-star absolute" style={{ top: '30%', left: '90%', animationDelay: '16s' }} />

      {/* Distant galaxies */}
      <div 
        className="absolute w-32 h-32 rounded-full opacity-10 animate-[pulse_8s_ease-in-out_infinite]"
        style={{
          top: '15%',
          right: '20%',
          background: 'radial-gradient(circle, rgba(167, 139, 250, 0.5) 0%, transparent 70%)',
          filter: 'blur(20px)',
        }}
      />
      <div 
        className="absolute w-24 h-24 rounded-full opacity-10 animate-[pulse_10s_ease-in-out_infinite_1s]"
        style={{
          bottom: '25%',
          left: '15%',
          background: 'radial-gradient(circle, rgba(96, 165, 250, 0.5) 0%, transparent 70%)',
          filter: 'blur(15px)',
        }}
      />

      {/* Orbital system */}
      <svg
        viewBox="0 0 800 800"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[140%] h-[140%] max-w-[1200px] opacity-[0.08]"
      >
        <circle
          cx="400"
          cy="400"
          r="350"
          fill="none"
          stroke="rgba(147, 197, 253, 0.5)"
          strokeWidth="0.5"
          strokeDasharray="4 8"
          className="animate-[spin_200s_linear_infinite]"
        />
        <circle
          cx="400"
          cy="400"
          r="250"
          fill="none"
          stroke="rgba(196, 181, 253, 0.4)"
          strokeWidth="0.5"
          className="animate-[spin_150s_linear_infinite_reverse]"
        />
        <circle
          cx="400"
          cy="400"
          r="150"
          fill="none"
          stroke="rgba(147, 197, 253, 0.3)"
          strokeWidth="0.5"
          strokeDasharray="2 6"
          className="animate-[spin_100s_linear_infinite]"
        />
      </svg>

      {/* Vignette overlay */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse at center, transparent 0%, rgba(3, 7, 18, 0.4) 100%)',
        }}
      />
    </div>
  );
};

export default DeepSpaceBackground;
